<template>
  <div
    class="no-data-state d-flex flex-column align-center justify-center text-center gap-3"
    data-testid="no-data-state"
  >
    <!-- <v-icon
      v-if="icon"
      :size="iconSize"
      :color="iconColor"
      class="no-data-state__icon"
      data-testid="no-data-state__icon"
    >
      {{ icon }}
    </v-icon> -->
    <h3 class="no-data-state__title font-weight-medium" data-testid="no-data-state__title">
      {{ title }}
    </h3>
    <!-- <p
      v-if="description"
      class="no-data-state__description text-body-1 mb-0"
      data-testid="no-data-state__description"
    >
      {{ description }}
    </p> -->
    <div v-if="showReset" class="">
      <v-btn
        color="primary"
        class="reset-btn text-transform-none"
        @click="$emit('reset')"
        data-testid="no-data-state__reset-btn"
      >
        {{ resetLabel }}
      </v-btn>
    </div>
    <slot />
  </div>
</template>

<script>
import { VARIANCE_ANALYSIS_UI } from '../utils/constants';

export default {
  name: 'NoDataState',
  props: {
    title: {
      type: String,
      default: VARIANCE_ANALYSIS_UI.NO_DATA_TITLE,
    },
    description: {
      type: String,
      default: VARIANCE_ANALYSIS_UI.NO_DATA_DESCRIPTION,
    },
    icon: {
      type: String,
      default: VARIANCE_ANALYSIS_UI.NO_DATA_ICON,
    },
    iconSize: {
      type: [Number, String],
      default: VARIANCE_ANALYSIS_UI.NO_DATA_ICON_SIZE,
    },
    iconColor: {
      type: String,
      default: 'grey lighten-1',
    },
    showReset: {
      type: Boolean,
      default: false,
    },
    resetLabel: {
      type: String,
      default: 'Reset View',
    },
  },
};
</script>

<style scoped>

</style>
